import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import moment from "moment";
import { checkInsApi } from "../api";
import { API_DATE_FORMAT } from "../../../app_constants";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_TABLE_DATA_LOADING = "saga/SET_TABLE_DATA_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const SET_DATA_POINTS_LOADING = "sagas/SET_DATA_POINTS_LOADING";
export const SET_HEAT_MAP_LOADING = "sagas/SET_HEAT_MAP_LOADING";

export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_CHART = "saga/FETCH_CHART";
export const FETCH_GRAPH = "saga/FETCH_GRAPH";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_GRAPH_SUCCESS = "saga/FETCH_GRAPH_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/FETCH_CHART_SUCCESS";
export const FETCH_FILTERS = "saga/FETCH_FILTERS";
export const FETCH_UPDATE_CHARTS = "saga/FETCH_UPDATE_CHARTS";
export const FETCH_DATA_POINTS_SUCCESS = "sagas/FETCH_DATA_POINTS_SUCCESS";

export const UPDATE_MEMBERSHIP_TYPE_FILTER = "saga/UPDATE_MEMBERSHIP_TYPE_FILTER";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_PERIOD_TYPE = "sagas/UPDATE_PERIOD_TYPE";
export const UPDATE_PERIOD_TYPE_SELECTED = "sagas/UPDATE_PERIOD_TYPE_SELECTED";
export const UPDATE_GROUP_BY_FILTER = "sagas/UPDATE_GROUP_BY_FILTER";
export const YEAR_OVER_YEAR_LOADING = "sagas/YEAR_OVER_YEAR_LOADING";
export const CHANGE_PERCENTAGE_TOGGLE = "sagas/CHANGE_PERCENTAGE_TOGGLE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  getTableData: createAction(FETCH_TABLE_DATA),
  updateData: createAction(FETCH_UPDATE_CHARTS),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  onChangePercentageToggle: createAction(CHANGE_PERCENTAGE_TOGGLE),
  updateGroupBy: createAction(UPDATE_GROUP_BY_FILTER),
  updateMembershipTypeFilter: createAction(UPDATE_MEMBERSHIP_TYPE_FILTER)
};

export default function* watchCheckIns() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, fetchModalTableData);
  yield takeLatest(FETCH_UPDATE_CHARTS, updateCharts);
  yield takeLatest(UPDATE_PERIOD_TYPE, updatePeriodTypeAndLoad);
  yield takeLatest([UPDATE_GROUP_BY_FILTER, CHANGE_PERCENTAGE_TOGGLE], fetchHeatMapChart);
}

export function* updatePeriodTypeAndLoad(payload) {
  yield put({ type: UPDATE_PERIOD_TYPE_SELECTED, payload: payload.payload });
  yield put({ type: YEAR_OVER_YEAR_LOADING, payload: true });
  try {
    yield call(fetchBreakdown);
    yield put({ type: YEAR_OVER_YEAR_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateCharts() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  const allSagas = [fetchHeatMapChart(), fetchBreakdown(), fetchDataPoints()];

  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield all(allSagas);
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getCurrentUserData({ payload }) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  const endDate = yield select((state) => state.checkIns.currentUser.calendarEndDate);

  yield put({
    type: SET_DATES,
    payload: {
      startDate: moment(endDate).startOf("month").format(API_DATE_FORMAT),
      endDate: endDate
    }
  });

  yield fetchFilters();

  const allSagas = [fetchHeatMapChart(), fetchBreakdown(), fetchDataPoints()];

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters() {
  const { commonParams } = yield getCommonApiParams();

  try {
    const { data } = yield call(checkInsApi.getFilters, {
      params: commonParams
    });

    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchHeatMapChart() {
  const { commonParams, show_percentage, group_by, membership_type_ids } =
    yield getCommonApiParams();

  if (!membership_type_ids.length) return;

  yield put({ type: SET_HEAT_MAP_LOADING, payload: true });

  try {
    const res = yield call(checkInsApi.getHeatmap, {
      ...commonParams,
      show_percentage,
      group_by,
      membership_type_ids
    });

    yield put({ type: FETCH_CHART_SUCCESS, payload: res.data });
    yield put({ type: SET_HEAT_MAP_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchCheckInsData({ apiMethod, successType, loadingType, additionalParams = {} }) {
  const { commonParams, membership_type_ids } = yield getCommonApiParams();

  if (!membership_type_ids.length) return;

  yield put({ type: loadingType, payload: true });

  try {
    const response = yield call(apiMethod, {
      ...commonParams,
      membership_type_ids,
      ...additionalParams
    });
    yield put({ type: successType, payload: response.data });
    yield put({ type: loadingType, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchBreakdown() {
  const { period_type } = yield select((state) => state.checkIns.selectedFilters);

  yield call(fetchCheckInsData, {
    apiMethod: checkInsApi.getBreakdown,
    successType: FETCH_GRAPH_SUCCESS,
    loadingType: YEAR_OVER_YEAR_LOADING,
    additionalParams: {
      period_type: period_type.name.toLowerCase().toString()
    }
  });
}

function* fetchDataPoints() {
  yield call(fetchCheckInsData, {
    apiMethod: checkInsApi.getDataPoints,
    successType: FETCH_DATA_POINTS_SUCCESS,
    loadingType: SET_DATA_POINTS_LOADING
  });
}

export function* fetchModalTableData(payload) {
  yield put({ type: SET_TABLE_DATA_LOADING, payload: true });
  const { commonParams, membership_type_ids } = yield getCommonApiParams();

  try {
    const { data } = yield call(checkInsApi.getModalData, {
      ...commonParams,
      tableDataUid: payload.payload.tableDataUid,
      membership_type_ids
    });

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: data });
  } catch (error) {
    console.error(error);
  }
}

export function* getCommonApiParams() {
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  return yield select((state) => {
    const {
      selectedRequestDates: { endDate, startDate },
      selectedFilters: { membership_types, group_by, show_percentage }
    } = state.checkIns;

    return {
      commonParams: {
        organization_id: organization_id.toString(),
        short_url,
        end_date: endDate,
        start_date: startDate
      },
      show_percentage,
      group_by: group_by.id,
      membership_type_ids: membership_types.map((obj) => obj.id)
    };
  });
}
